import React from 'react';
import { func, string } from 'prop-types';

import { Button } from '@snapask/common-components';

import LineInput from '@dragonfruit/components/fields/LineInput';

import styles from './CopyReferral.scss';

function CopyReferral({ referralCode, onClickCopy, btnText }) {
  return (
    <div className={styles.root}>
      <div className={styles.input}>
        <LineInput
          type="text"
          value={referralCode}
          onChange={() => {}}
          disabled
        />
      </div>
      <div className={styles.spacer} />
      <div className={styles.btnContainer}>
        <Button text={btnText} secondary onClick={onClickCopy} />
      </div>
    </div>
  );
}

CopyReferral.propTypes = {
  btnText: string.isRequired,
  referralCode: string.isRequired,
  onClickCopy: func.isRequired,
};

export default CopyReferral;



// WEBPACK FOOTER //
// ./app/containers/Account/children/AccountReferral/components/CopyReferral/CopyReferral.jsx